function vehicleSelector (formElement) {
  /**
   * UI
   */
  // The Display Elements
  this.$formElement = formElement;
  this.$makeField = $('#vehicle-selector-make');
  this.$modelField = $('#vehicle-selector-model');
  this.$yearField = $('#vehicle-selector-year');
  this.$optionField = $('#vehicle-selector-option');
  this.$submitButton = $('#vehicle-selector-submit');
  this.$container = $('#vehicle-selector__container');
  this.$headerComponent = $('#vehicle-title__component');
  this.$sizeComponent = $('#vehicle-size__component');
  this.$facetFilter = $('#boost-pfs-filter-tree');

  // Field Default Option Values
  this.fieldDefaults = {
    make: '<option value="">MAKE</option>' +
      '<option value="chevrolet">Chevrolet</option>' +
      '<option value="gmc">GMC</option>' +
      '<option value="dodge">Dodge</option>' +
      '<option value="ford">Ford</option>' +
      '<option value="jeep">Jeep</option>' +
      '<option value="nissan">Nissan</option>' +
      '<option value="ram">Ram</option>' +
      '<option value="toyota">Toyota</option>' +
      '<option value="">-------------</option>' +
      '<option value="acura">Acura</option>' +
      '<option value="aston-martin">Aston Martin</option>' +
      '<option value="audi">Audi</option>' +
      '<option value="bentley">Bentley</option>' +
      '<option value="bmw">BMW</option>' +
      '<option value="bmw-alpina">BMW Alpina</option>' +
      '<option value="buick">Buick</option>' +
      '<option value="cadillac">Cadillac</option>' +
      '<option value="chrysler">Chrysler</option>' +
      '<option value="daihatsu">Daihatsu</option>' +
      '<option value="datsun">Datsun</option>' +
      '<option value="eagle">Eagle</option>' +
      '<option value="geo">GEO</option>' +
      '<option value="honda">Honda</option>' +
      '<option value="hummer">Hummer</option>' +
      '<option value="infiniti">Infiniti</option>' +
      '<option value="isuzu">Isuzu</option>' +
      '<option value="jaguar">Jaguar</option>' +
      '<option value="land-rover">Land Rover</option>' +
      '<option value="lexus">Lexus</option>' +
      '<option value="lincoln">Lincoln</option>' +
      '<option value="lotus">Lotus</option>' +
      '<option value="mazda">Mazda</option>' +
      '<option value="mclaren">McLaren</option>' +
      '<option value="mercedes">Mercedes-Benz</option>' +
      '<option value="mercury">Mercury</option>' +
      '<option value="mg">MG</option>' +
      '<option value="mini">MINI</option>' +
      '<option value="mitsubishi">Mitsubishi</option>' +
      '<option value="mosler">Mosler</option>' +
      '<option value="oldsmobile">Oldsmobile</option>' +
      '<option value="opel">Opel</option>' +
      '<option value="panoz">Panoz</option>' +
      '<option value="plymouth">Plymouth</option>' +
      '<option value="pontiac">Pontiac</option>' +
      '<option value="porsche">Porsche</option>' +
      '<option value="rover">Rover</option>' +
      '<option value="saleen">Saleen</option>' +
      '<option value="saturn">Saturn</option>' +
      '<option value="scion">Scion</option>' +
      '<option value="smart">Smart</option>' +
      '<option value="subaru">Subaru</option>' +
      '<option value="suzuki">Suzuki</option>' +
      '<option value="vauxhall">Vauxhall</option>' +
      '<option value="volkswagen">Volkswagen</option>',
    model: '<option value="">MODEL</option>',
    year: '<option value="">YEAR</option>',
    option: '<option value="">OPTION</option>',
  };

  /**
   * State
   */
  this.vehicleData = {
    make: '',
    model: '',
    year: '',
    option: '',
  };

  this.fieldData = {
    make: '',
    model: '',
    year: '',
    option: '',
  };

  this.sizeData = [];
  this.selectedSize = 0;

  // Initialize
  this.loadData();
  this.populateFields();
  this.bindEvents();

  if (this.vehicleData.option !== '') {
    this.$makeField.attr('disabled', true);

    // Hide Vehicle Selector if a vehicle is selected
    this.$container.css('display', 'none');
  }
}

vehicleSelector.prototype.bindEvents = function () {
  this.$makeField.on('change', function () {
    this.fetchModels(this.$makeField.val());
    this.fetchYears(this.$makeField.val(), this.$modelField.val());
  }.bind(this));

  this.$modelField.on('change', function () {
    this.fetchYears(this.$makeField.val(), this.$modelField.val());
  }.bind(this));

  this.$yearField.on('change', function () {
    this.fetchOptions(this.$makeField.val(), this.$modelField.val(), this.$yearField.val());
  }.bind(this));

  this.$optionField.on('change', function () {
    this.fetchSizes(this.$makeField.val(), this.$modelField.val(), this.$yearField.val(), this.$optionField.val());
    this.$submitButton.attr('disabled', false);
  }.bind(this));

  this.$formElement.on('submit', function (e) {
    e.preventDefault();
    this.submit();
  }.bind(this));

  this.renderTitle();
  this.renderSizes();
};

vehicleSelector.prototype.createURLQueryForVendors = function (make) {
  var sizeData=this.sizeData[0];
  if(this.selectedSize){
    if(this.sizeData[this.selectedSize]!=undefined){
      sizeData = this.sizeData[this.selectedSize];
    }
  }
  //var sizeData = (this.selectedSize) ? this.sizeData[this.selectedSize] : this.sizeData[0];
  var sizeStr = [
    sizeData.tire_width,
    sizeData.tire_aspect_ratio,
    sizeData.rim_diameter,
  ].join('+');

  var loadRatings = 'HPEFGDC';
  var queryString = loadRatings.split('').map(function (load) {
    return sizeStr + '+' + load;
  }).join(',');

  return 'pf_v_vendor=' + queryString;
};

vehicleSelector.prototype.createURLQueryForTags = function (make) {
  //var sizeData = (this.selectedSize) ? this.sizeData[this.selectedSize] : this.sizeData[0];
  var sizeDataNew=this.sizeData[0];
  if(this.selectedSize){
    if(this.sizeData[this.selectedSize]!=undefined){
      sizeDataNew = this.sizeData[this.selectedSize];
    }
  }
  if(jQuery('.select-bar__panel-size').css('display')=='none'){
    var queryString = [
      '?pf_t_tire_width=' + sizeDataNew.tire_width,,
      '&pf_t_tire_ratio=' + sizeDataNew.tire_aspect_ratio,,
      '&pf_t_rim_size=' + sizeDataNew.rim_diameter,,
      '&by-vehicle=1',
    ].join('');
  }else{
    var queryString = [
      '?pf_t_tire_width=' + sizeDataNew.tire_width,,
      '&pf_t_tire_ratio=' + sizeDataNew.tire_aspect_ratio,,
      '&pf_t_rim_size=' + sizeDataNew.rim_diameter,,
    ].join('');
  }

  return queryString;
};

vehicleSelector.prototype.fetchModels = function (make) {
  $.getJSON('https://api.wheel-size.com/v2/models/', {
    user_key: 'edb6072e3c6d71ba479b85b4c95907a1',
    make: make,
    countries: 'us,gb,jp,de',
  }).done(function (data) {
    this.populateField('model', data.data);
    this.resetField('year');
    this.resetField('option');
  }
  .bind(this));
};

vehicleSelector.prototype.fetchYears = function (make, model) {
  $.getJSON('https://api.wheel-size.com/v2/years/', {
    user_key: 'edb6072e3c6d71ba479b85b4c95907a1',
    make: make,
    model: model,
    countries: 'us,gb,jp,de',
  }).done(function (data) {
    this.populateField('year', data.data);
    this.resetField('option');
  }
  .bind(this));
};

vehicleSelector.prototype.fetchOptions = function (make, model, year) {
  $.getJSON('https://api.wheel-size.com/v2/modifications/', {
    user_key: 'edb6072e3c6d71ba479b85b4c95907a1',
    make: make,
    model: model,
    year: year,
    countries: 'us,gb,jp,de',
  }).done(function (data) {
    this.populateField('option', data.data);
  }
  .bind(this));
};

vehicleSelector.prototype.fetchSizes = function (make, model, year, trim) {
  $.getJSON('https://api.wheel-size.com/v2/search/by_model/', {
    user_key: 'edb6072e3c6d71ba479b85b4c95907a1',
    make: make,
    model: model,
    year: year,
    modification:trim,
    countries: 'us,gb,jp,de'
  }).done(function (data) {
    var data1=data.data;
    var sizes = $.map(data1[0].wheels, function (specs, index) {
      return {
        tire: specs.front.tire,
        tire_width: specs.front.tire_width,
        tire_aspect_ratio: specs.front.tire_aspect_ratio,
        rim_diameter: specs.front.rim_diameter,
      };
    });
    this.setSizeData(sizes);
  }
  .bind(this));
};

vehicleSelector.prototype.loadData = function () {
  // Hydrate State
  if (window.localStorage.getItem('vehicleData')) {
    this.vehicleData = JSON.parse(window.localStorage.getItem('vehicleData'));
  }

  if (window.localStorage.getItem('fieldData')) {
    this.fieldData = JSON.parse(window.localStorage.getItem('fieldData'));
  }
  else {
    this.fieldData.make = this.fieldDefaults.make;
    this.fieldData.model = this.fieldDefaults.model;
    this.fieldData.year = this.fieldDefaults.year;
    this.fieldData.option = this.fieldDefaults.option;
  }

  if (window.localStorage.getItem('sizeData')) {
    this.sizeData = JSON.parse(window.localStorage.getItem('sizeData'));
  }

  if (window.localStorage.getItem('selectedSize')) {
    this.selectedSize = JSON.parse(window.localStorage.getItem('selectedSize'));
  }
};

vehicleSelector.prototype.populateField = function (fieldName, data) {
  var field = this['$' + fieldName + 'Field'];

  field.html(this.fieldDefaults[fieldName]);
  $.each(data, function(index, value) {
    field.append('<option value="' + value.slug + '">' + value.name + '</option>');
  });
  field.attr('disabled', false);
};

vehicleSelector.prototype.populateFields = function () {
  var isDisabled = window.localStorage.getItem('vehicleData');

  this.$makeField
    .html(this.fieldData.make)
    .val(this.vehicleData.make.slug)
    .attr('disabled', isDisabled);
  this.$modelField
    .html(this.fieldData.model)
    .val(this.vehicleData.model.slug)
    .attr('disabled', isDisabled);
  this.$yearField
    .html(this.fieldData.year)
    .val(this.vehicleData.year.slug)
    .attr('disabled', isDisabled);
  this.$optionField
    .html(this.fieldData.option)
    .val(this.vehicleData.option.slug)
    .attr('disabled', isDisabled);
};

vehicleSelector.prototype.renderSizes = function () {
  if (this.sizeData.length === 0) {
    this.$sizeComponent.html('');
    return;
  }

  function container (buttons) {
    return (
      '<div class="vehicle-size__header">Select a Size</div>' +
      '<div class="vehicle-size__entries" id="vehicle-size__entries">' +
        buttons +
        // '<button class="vehicle-size__entry" aria-label="All Tires" role="button" id="vehicle-size__entry-all">' +
        //   '<div class="vehicle-size__entry-label">All Tires</div>' +
        // '</button>' +
      '</div>'
    );
  }

  var hasURLQuery = (window.location.search.includes('pf_t_'));
  if (!hasURLQuery) {
    this.selectedSize = -1;
  }
  var _this = this;
  var html = this.sizeData.map(function (size, i) {
    function isActive () {
      if (_this.selectedSize == i) {
        return 'active';
      } else {
        return '';
      }
    }

    return (
      '<button class="vehicle-size__entry ' + isActive() + '" data-index="' + i + '" aria-label="' + size.tire + '" role="button">' +
        '<div class="vehicle-size__entry-wheel">' +
          '<div>' + size.rim_diameter + '<span>\u2033</span></div>' +
          '<div class="vehicle-size__entry-info">Wheels</div>' +
        '</div>' +
        '<div class="vehicle-size__entry-label">' + size.tire + '</div>' +
      '</button>'
    );
  }).join('');

  this.$sizeComponent.html(container(html));

  var _this = this;
  $('#vehicle-size__entries button').each(function (index, el) {
    var $el = $(el);
    $el.on('click', function () {
      _this.setSelectedSize($el.attr('data-index'));
      _this.submit();
    }.bind(this));
  });
};

vehicleSelector.prototype.renderTitle = function () {
  if (
    this.vehicleData.make &&
    this.vehicleData.model &&
    this.vehicleData.year &&
    this.vehicleData.option
  ) {
    var title = [
      this.vehicleData.year.value,
      this.vehicleData.make.value,
      this.vehicleData.model.value,
      '<span class="vehicle-title__header-option">' + this.vehicleData.option.value + '</span>',
    ].join(' ');

    var actions = (
      '<div class="vehicle-title__actions">' +
        '<button class="vehicle-title__clear-vehicle" id="vehicle-title__clear-vehicle" aria-label="Clear Vehicle">Clear Vehicle</button>' +
      '</div>'
    )
  }

  function container (title, actions) {
    return (
      '<div class="vehicle-title__header">' + title  + '</div>' +
      actions
    );
  }

  if (title && actions) {
    this.$headerComponent.html(container(title, actions));

    $('#vehicle-title__clear-vehicle').on('click', function () {
      this.reset();
    }.bind(this));
  }
};

vehicleSelector.prototype.reset = function () {
  // Reset State
  this.vehicleData = { make: '', model: '', year: '', option: '' };
  this.fieldData = { make: '', model: '', year: '', option: '' };
  this.sizeData = [];
  this.selectedSize = 0;

  // Clear LocalStorage
  window.localStorage.removeItem('fieldData');
  window.localStorage.removeItem('sizeData');
  window.localStorage.removeItem('selectedSize');
  window.localStorage.removeItem('vehicleData');

  // Reload
  window.location.search = '';
};

vehicleSelector.prototype.resetField = function (fieldName) {
  var field = this['$' + fieldName + 'Field'];

  field.html(this.fieldDefaults[fieldName]);

  if (fieldName === 'make' && this.vehicleData.option !== '') {
    field.attr('disabled', false);
  }
};

vehicleSelector.prototype.saveFieldData = function () {
  window.localStorage.setItem('fieldData', JSON.stringify(this.fieldData));
};

vehicleSelector.prototype.saveSizeData = function () {
  window.localStorage.setItem('sizeData', JSON.stringify(this.sizeData));
};

vehicleSelector.prototype.saveSelectedSize = function () {
  window.localStorage.setItem('selectedSize', JSON.stringify(this.selectedSize));
};

vehicleSelector.prototype.saveVehicleData = function () {
  console.log(this.vehicleData);
  window.localStorage.setItem('vehicleData', JSON.stringify(this.vehicleData));
};

vehicleSelector.prototype.setFieldData = function () {
  this.fieldData.make = this.$makeField.html();
  this.fieldData.model = this.$modelField.html();
  this.fieldData.year = this.$yearField.html();
  this.fieldData.option = this.$optionField.html();
  this.saveFieldData();
};

vehicleSelector.prototype.setSizeData = function (data) {
  this.sizeData = data;
  this.saveSizeData();
};

vehicleSelector.prototype.setSelectedSize = function (index) {
  this.selectedSize = index;
  this.saveSelectedSize();
};

vehicleSelector.prototype.setVehicleData = function () {
  this.vehicleData = {
    make: {
      slug: this.$makeField.val(),
      value: this.$makeField.find('option:selected').text(),
    },
    model: {
      slug: this.$modelField.val(),
      value: this.$modelField.find('option:selected').text(),
    },
    year: {
      slug: this.$yearField.val(),
      value: this.$yearField.find('option:selected').text(),
    },
    option: {
      slug: this.$optionField.val(),
      value: this.$optionField.find('option:selected').text(),
    },
  }
  this.saveVehicleData();
};

vehicleSelector.prototype.submit = function () {

  if (this.$optionField.val()) {
    // Set State
    this.setFieldData();
    this.setVehicleData();
  }

  window.location.search = this.createURLQueryForTags();
};

$(document).ready(function () {
  var $form = $('#vehicle-selector-form');
  new vehicleSelector($form);
  jQuery('.collection__filter').hide();
  jQuery('#vehicle-selector__container').show();
});
$(document).load('bind',function(){
  $('#vehicle-selector-make').removeAttr('disabled');
  $('#vehicle-selector-model').removeAttr('disabled');
  $('#vehicle-selector-year').removeAttr('disabled');
  $('#vehicle-selector-option').removeAttr('disabled');
  $('#vehicle-selector-submit').removeAttr('disabled');
})
